export default "__VITE_ASSET__OFSJ5YKh__"